import axios from 'axios';
import queryString from 'query-string';
import interceptorResponse from "./interceptorResponse";
import interceptorRequest from "./interceptorRequest";
import appEnv from "../../../AppEnv";
import {logoutAuthorized} from "../../../_helpers/HNTUtil";

export const axiosNodeClient = axios.create({
  timeout: appEnv.TIME_OUT,
  headers: {
    'Content-type': 'application/json',
  },
  paramsSerializer: params => queryString.stringify(params)
});


axiosNodeClient.defaults.baseURL = appEnv.HOST_SERVICE_NODE;
axiosNodeClient.interceptors.request.use(interceptorRequest);
axiosNodeClient.interceptors.response.use(interceptorResponse, handleError);

function handleError (error) {
  console.error(error.message, error);

  if (error.response && error.response.status) {
    if ([401, 403].indexOf(error.response.status) !== -1) {
      console.warn('Auto logout with error code 401 Unauthorized or 403 Forbidden response returned from api');
      logoutAuthorized();
    }
    throw {
      status: error.response.status,
      statusText: error.response.statusText,
      message: error.response.data.message
    }
  } else {
    throw {
      status: 500,
      statusText: '',
      message: error.message
    };
  }
}

export default axiosNodeClient;
